
/* Library */
import React, { Component } from 'react';
import { browserHistory } from 'react-router';
import commonUtil from '../../../../../utils/commonUtil';
import ModalPopover from '../../../../../components/ZUILib/ModalPopover';
import InputButton from '../../../../../components/ZUILib/InputButton';
import ApplyCSS from '../../../../../components/ApplyCSS';
import Image from '../../../../../components/ZUILib/Image/Image';
import Tagging from '../../../../../components/Tagging/Tagging';
import RadioButton from '../../../../../components/ZUILib/RadioButton';
const applicationRoutes = commonUtil.getApplicationRoutes();

const pageName = 'PredeterminedLists';


export default class PredeterminedListsWeb extends Component {
    constructor(props) {
        super(props);
        this.deliveryMode = 'physical';
        this.repoId = 0;
        this.itemName = '';
    }
  openPage = (itemId) => {
    browserHistory.push(commonUtil.getRouteByParameter(applicationRoutes.predeterminedListsDetails, { eventID: this.props.eventId, repoId: itemId }));
  }

  backToAdmin = () => {
    const dataLayer = {};
    dataLayer.event =  'Mesa de Regalos';
    dataLayer.eventCategory= 'Mesa de Regalos';
    dataLayer.eventAction = 'Agregaste a tu mesa de regalos';
    dataLayer.eventLabel = 'Ir a mi mesa de regalos';
    dataLayer.dimension77 = this.itemName;
    this.tagging.applyGTM('Mesa de Regalos', dataLayer);
    browserHistory.push(commonUtil.getRouteByParameter(applicationRoutes.giftList, { eventID: this.props.eventId }));
    this.addGiftModal.handleHide();
  }
  handleAddListToMyList = (repoId,  itemName,deliveryMode) => {
    const _dataLayer = {};
    _dataLayer.event = 'evGiftList';
    _dataLayer.nameList = itemName;
    _dataLayer.selectOption = 'Agregar Artículos a mi lista';
    this.tagging.applyGTM('evGiftList', _dataLayer);
    const dataLayer = {};
    dataLayer.event =  'Mesa de Regalos';
    dataLayer.eventCategory= 'Mesa de Regalos';
    dataLayer.eventAction = 'Agregar artículos a mi lista';
    dataLayer.eventLabel = 'Regalos '+deliveryMode;
    dataLayer.dimension77 = 'Preferencia de regalo';
    this.tagging.applyGTM('Mesa de Regalos', dataLayer);
    this.props.onAddListToMyList(repoId,deliveryMode);
  }
  showAddModalType = () =>{
    const dataLayer = {};
    dataLayer.event =  'Mesa de Regalos';
    dataLayer.eventCategory= 'Mesa de Regalos';
    dataLayer.eventAction = 'Agregar artículos a mi lista';
    dataLayer.eventLabel = this.itemName;
    dataLayer.dimension77 = 'Listas Predeterminadas';
    this.tagging.applyGTM('Mesa de Regalos', dataLayer);
    const dataLayer2 = {};
    dataLayer2.event =  'Mesa de Regalos';
    dataLayer2.eventCategory= 'Mesa de Regalos';
    dataLayer2.eventAction = 'Agregar artículos a mi lista';
    dataLayer2.eventLabel = 'Preferencia de regalo';
    this.tagging.applyGTM('Mesa de Regalos', dataLayer2);
    this.addGiftModalType.handleShow();
  }
  showAddModal = () => {
    const dataLayer = {};
    dataLayer.event =  'Mesa de Regalos';
    dataLayer.eventCategory= 'Mesa de Regalos';
    dataLayer.eventAction = 'Agregaste a tu mesa de regalos';
    dataLayer.eventLabel = 'Regalos '+ this.deliveryMode;
    dataLayer.dimension77 = this.itemName;
    this.tagging.applyGTM('Mesa de Regalos', dataLayer);
    this.addGiftModal.handleShow();
  }
  _setDeliveryMode = (ref) => {
    this.deliveryMode = ref.value;
   
  }
  getViewListDetailButtonAttributes = (id, itemName) => {
    const label = this.props.labels;
    const viewListDetailButton = {
      name: 'Ver Artículos de la lista',
      style: 'btnSecondarySpecial size-Full',
      type: 'button',
      value: commonUtil.getLabel(label.PredeterminedPage, 'predetermine.seelist.button.label'),
      onClickHandler: () => {
        if (viewListDetailButton) {
          const _dataLayer = {};
          _dataLayer.event = 'evGiftList';
          _dataLayer.nameList = itemName;
          _dataLayer.selectOption = 'Ver Artículos de lista';
          this.tagging.applyGTM('evGiftList', _dataLayer);
          const dataLayer2 = {};
          dataLayer2.event =  'Mesa de Regalos';
          dataLayer2.eventCategory= 'Mesa de Regalos';
          dataLayer2.eventAction = 'Ver articulos de lista';
          dataLayer2.eventLabel = itemName;
          dataLayer2.dimension77 = 'Listas Predeterminadas';
          this.tagging.applyGTM('Mesa de Regalos', dataLayer2);
          
        }
        this.openPage(id);
      },
    };
    return viewListDetailButton;
  }

  getItemInfo = (predeterminedListInfo) => {
    const label = this.props.labels;
    const addListToGiftList = {
      name: 'Agregar artículos a mi lista',
      style: 'btnPrimary addThisList size-Full mt10',
      type: 'button',
      iconClass: 'iconRight icon-flecha_lightsvg_derecha',
      value: commonUtil.getLabel(label.PredeterminedPage, 'predetermine.addtolist.button.label'),
    };
    const goToMyGiftTable = {
      name: 'Ir a mi mesa de regalos',
      style: 'btnPrimarySpecial size-medium',
      type: 'button',
      iconClass: 'iconRight icon-flecha_lightsvg_derecha',
      value: commonUtil.getLabel(label.PredeterminedPage, 'predetermine.successpage.gotogifts.button.label'),
      onClickHandler: this.backToAdmin,
    };
    const continueAddingGiftType = {
        name: 'Continuar',
        style: 'btnPrimary size-Full',
        type: 'button',
        value: 'Continuar',
      };
    const addPredeterminedItemInfo = this.props.addPredeterminedItemInfo ? this.props.addPredeterminedItemInfo[0] : null;
    const _typeListPredetermined = {
        htmlId: 'typeListPredetermined',
        title: 'Tipo Lista',
        displayName: 'Tipo Lista',
        name: 'typeListPredetermined',
        defaultValue: 'physical',
        options: [
          {
            id: 'typePhysical',
            value: 'physical',
            title: 'Regalos fisicos',
            displayName: 'Regalos fisicos',
            labelResourceId: 'Regalos fisicos',
            selected: true,
          },
          {
            id: 'typeElectronic',
            value: 'electronic',
            title: 'Regalos electrónicos',
            displayName: 'Regalos electrónicos',
            labelResourceId: 'Regalos electronicos',
          },
        ],
      };
    return predeterminedListInfo.map((list, index) => {
      this.defaultImage = commonUtil.getAssetURL() + 'images/admin/adminImage.png'; const _imgsrc1 = [
        {
          media: '(max-width: 465px)',
          srcSet: list.imageURL,
        },
      ];
      const imageAttr1 = {
        id: 'img1',
        alt: 'Liverpool',
        src: list.imageURL || this.defaultImage, // TODO: Need to upload all images in static asset

      };

      const newAddListToGiftList = Object.assign({}, addListToGiftList);
      newAddListToGiftList.onClickHandler = () => { this.repoId =list.itemId;this.itemName = list.itemName;  this.showAddModalType(); };
      const newAddListInGiftListType = Object.assign({}, continueAddingGiftType);
      newAddListInGiftListType.onClickHandler = () => { this.addGiftModalType.handleHide(); this.showAddModal();this.handleAddListToMyList(this.repoId,this.itemName ,this.deliveryMode); };
      

      return (<div className="col-xs-12 itemList selected" key={index}>
        <Tagging ref={tagging => this.tagging = tagging} />
        <div className="descriptionList">
          <h2 className="titleModule">{list && list.itemName && list.itemName.toUpperCase()}</h2>
          <div className="itemListQuantity"><span>{list && list.noOfItems} &nbsp;</span><span>{commonUtil.getLabel(label.PredeterminedPage, 'predetermine.listpage.total.articles')}</span></div>
          <div className="itemListRange"><span>{commonUtil.getLabel(label.PredeterminedPage, 'predetermine.listpage.gifts.label1')} {commonUtil.getCurrency(list.minPrice)} {commonUtil.getLabel(label.PredeterminedPage, 'predetermine.listpage.gifts.label2')} {commonUtil.getCurrency(list.maxPrice)}</span></div>
          <div className="itemListValue"><span>{commonUtil.getLabel(label.PredeterminedPage, 'predetermine.listpage.total.label')}</span><span className="value">{commonUtil.getCurrency(list.totalPrice)}</span></div>
        </div>
        <div className="imgList">

          <Image imageAttr={imageAttr1} _imgsrc={_imgsrc1} />

          <div className="addedMessage" />
        </div>
        <div className="buttonList">
          <InputButton buttonAttr={this.getViewListDetailButtonAttributes(list.itemId, list.itemName)} />
          <InputButton buttonAttr={newAddListToGiftList} />
        </div>
        <div id="myModalAddList" className="container">
        <ModalPopover
              ref={add => this.addGiftModalType = add}
              isModal="true" outerClass="modal-sm" modalId="predeter-con-pop"
            >
            <div className="container">
              <div className="row">
                <div className="col-md-12">
                <button className="close" id="closeModal" type="button" data-dismiss="modal">×</button>
                    <p><h4>Preferencia de regalo</h4></p>
                    <hr/>
                   
                </div>
                </div>
                <div className="row">
                    <div className="col-md-6 col-sm-offset-3">
                        {_typeListPredetermined.options.map(option => (
                        <p>
                            <RadioButton displayName={option.displayName} radioCssClass={'radio'} name={_typeListPredetermined.name} onChangeFunction={this._setDeliveryMode} value={option.value} checked={option.selected ? _typeListPredetermined.defaultValue === option.value : false} />
                        
                        </p>
                        ))}
                        <p>
                            <br/>
                        <InputButton buttonAttr={newAddListInGiftListType} />
                        </p>
                    </div>
                </div>
                </div>
            </ModalPopover>
          <ModalPopover
            ref={add => this.addGiftModal = add}
            isModal="true" outerClass="modal-lg"
          >
            <button className="close" id="closeModal" type="button" data-dismiss="modal">×</button>
            <div className="alert-container"><i className="icon-estado_de_mensaje_aprobado" />
              <p className="txt-alert">{commonUtil.getLabel(label.PredeterminedPage, 'predetermine.successpage.message')}  &nbsp; 1 <span>{commonUtil.getLabel(label.PredeterminedPage, 'predetermined.list.label')}</span>&nbsp; {commonUtil.getLabel(label.PredeterminedPage, 'predetermine.successpage.message1')}</p>
            </div>
            {addPredeterminedItemInfo ?
              <div className="row modal-product">
                <div className="col-xs-12">
                  <div className="row">
                    <div className="col-xs-6">
                      <div className="imgList">
                        {addPredeterminedItemInfo.imageURL ? <img src={addPredeterminedItemInfo.imageURL} className="img-responsive" /> : <img src={commonUtil.getAssetURL() + '/images/ooooooooooo.jpg'} className="img-responsive" />}
                      </div>
                    </div>
                    <div className="col-xs-6">
                      <div className="descriptionList">

                        <h4 className="title">{addPredeterminedItemInfo && addPredeterminedItemInfo.itemName && addPredeterminedItemInfo.itemName.toUpperCase()}</h4>
                        <p className="articles"><span>{addPredeterminedItemInfo.noOfItems}</span><span> {commonUtil.getLabel(label.PredeterminedPage, 'predetermine.successpage.total.articles')}</span></p>
                        <p className="priceRange"><span>{commonUtil.getLabel(label.PredeterminedPage, 'predetermine.successpage.gifts.label1')} {commonUtil.getCurrency(addPredeterminedItemInfo.minPrice)} {commonUtil.getLabel(label.PredeterminedPage, 'predetermine.successpage.gifts.label2')} {commonUtil.getCurrency(addPredeterminedItemInfo.maxPrice)}</span></p>
                        <p><span>{commonUtil.getLabel(label.PredeterminedPage, 'predetermine.successpage.total.label')}</span><span className="value">{commonUtil.getCurrency(addPredeterminedItemInfo.totalPrice)} {addPredeterminedItemInfo.itemId}</span></p>
                        <p className="priceRange giftPreference"><span>Preferencia de regalo:</span></p>
                        <p className="giftElectronicPhysical"><span>Regalos {this.deliveryMode == 'electronic' ? 'electrónicos' : 'físicos' }</span></p>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="row">
                  <div className="col-xs-12 buttons">
                    <InputButton buttonAttr={goToMyGiftTable} />
                  </div>
                </div>
              </div> : null}
          </ModalPopover>


        </div>

      </div>);
    });
  }
  render() {
    const predeterminedListInfo = this.props.predeterminedListInfo;
    const label = this.props.labels;


    return (
      <div className="defaultList">
        <ApplyCSS pageName={pageName} />
        <div className="row headerCLP">
          <div className="col-md-12" />
        </div>
        <h1 className="titleSection">{commonUtil.getLabel(label.PredeterminedPage, 'predetermine.heading.label')}</h1>
        <p className="subtitleModule">{commonUtil.getLabel(label.PredeterminedPage, 'predetermined.heading.text')}</p>

        <div className="row itemListBlock">
          {this.getItemInfo(predeterminedListInfo)}
        </div>

      </div>

    );
  }
}

